export const ADD_ACTION = 'add'
export const REMOVE_ACTION = 'remove'
